import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CheckModelUI } from './finalizeCheckImportChecksGrid.component';

export interface ICellRendererParamsForFinalizeCheckImportGridAction extends ICellRendererParams {
    hasEditPermission: () => boolean;
    enableSaveRow: () => boolean;
    rowBeingEdited: () => CheckModelUI;
    edit: (params: ICellRendererParamsForFinalizeCheckImportGridAction) => void;
    save: (params: ICellRendererParamsForFinalizeCheckImportGridAction) => Promise<void>;
    cancel: (params: ICellRendererParamsForFinalizeCheckImportGridAction) => void;
}

@Component({
    selector: 'finalize-check-import-grid-action-cell',
    template: ` @if (hasEditPermission && !params.rowBeingEdited() && !row.isTotal) {
            <button
                type="button"
                class="ace-btn btn-primary has-icon grid-action-button"
                (click)="onEditClicked()"
                [disabled]="!row.candidateCheckReferenceNums?.length"
                title="Edit"
            >
                <i class="fa fa-pencil"></i>
            </button>
        }
        @if (params.rowBeingEdited()?.paymentBatchCheckImportCheckId === row.paymentBatchCheckImportCheckId) {
            <button
                type="button"
                style="display: inline-block; visibility: visible;"
                class="ace-btn btn-primary has-icon grid-action-button"
                title="Save"
                [disabled]="!params.enableSaveRow()"
                (click)="onSaveClicked()"
            >
                <i class="fa fa-save"></i>
            </button>
            <button
                type="button"
                style="display: inline-block; visibility: visible;"
                class="ace-btn has-icon btn-primary btn-danger grid-action-button"
                title="Cancel"
                (click)="onCancelClicked()"
            >
                <i class="fa fa-close"></i>
            </button>
        }`,
    standalone: false,
})
export class FinalizeCheckImportGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForFinalizeCheckImportGridAction;
    hasEditPermission: boolean;
    row: CheckModelUI;

    agInit(params: ICellRendererParamsForFinalizeCheckImportGridAction): void {
        this.params = params;
        this.row = params.data as CheckModelUI;
        this.hasEditPermission = params.hasEditPermission();
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onEditClicked(): void {
        this.params.edit(this.params);
    }

    async onSaveClicked(): Promise<void> {
        await this.params.save(this.params);
    }

    onCancelClicked(): void {
        this.params.cancel(this.params);
    }
}
